var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 998,
    height: 1080,
    viewBox: "0 0 998 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88354 433.545C31.7434 299.168 92.7888 174.563 178.252 71.9478C278.366 -47.77 412.665 -138.169 571.383 -182.147C573.825 -182.147 576.267 -182.147 578.709 -184.59C610.452 -191.92 644.637 -169.931 649.521 -135.726C656.846 -103.964 634.87 -72.2016 603.127 -64.8719C468.827 -25.7804 356.504 49.9591 271.041 150.131C197.787 238.087 144.067 352.919 122.09 470.193C117.207 492.182 97.6723 511.728 73.2542 516.614C39.0689 523.944 7.32542 501.955 0 467.75C0 455.534 2.44173 443.318 4.88354 433.545Z",
    fill: "url(#paint0_linear_1005_33979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M852.19 321.157C883.934 345.589 913.235 372.464 937.654 401.783C996.257 467.75 1035.33 550.819 1047.53 646.105C1052.42 707.185 1045.09 765.823 1025.56 822.017C1006.02 878.211 971.839 931.962 930.328 973.497C876.609 1027.25 813.122 1061.45 747.193 1078.55C742.309 1081 734.983 1081 727.658 1081C693.473 1081 666.613 1051.68 666.613 1019.92C666.613 988.156 686.148 963.724 713.008 956.394C761.844 944.178 808.238 922.189 844.865 885.541C910.794 817.13 935.212 719.402 923.003 626.559C910.794 541.046 871.725 489.739 810.68 438.431C778.937 455.534 749.635 477.522 722.775 511.728C688.589 553.262 669.055 602.127 664.172 650.991C659.288 677.867 637.311 699.856 610.451 702.299C576.266 704.742 546.965 682.753 542.081 648.548C539.639 641.218 539.639 636.332 542.081 629.003C551.848 560.592 578.708 494.626 625.102 435.988C649.521 404.227 678.822 377.351 710.566 355.362C711.787 354.14 713.007 353.529 714.228 352.919C715.449 352.308 716.67 351.697 717.891 350.476C748.223 329.052 756.391 312.847 761.449 302.813C763.313 299.115 764.754 296.255 766.727 294.281C771.611 286.951 778.936 282.065 788.703 282.065C797.521 282.065 806.34 288.04 813.361 292.797L813.365 292.799C814.119 293.31 814.853 293.807 815.563 294.281C821.668 299.168 827.772 303.443 833.877 307.719C839.981 311.995 846.086 316.27 852.19 321.157Z",
    fill: "url(#paint1_linear_1005_33979)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M903.468 362.692L899.806 360.248C901.027 360.859 902.248 361.47 903.468 362.692Z",
    fill: "url(#paint2_linear_1005_33979)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M899.806 360.248L896.143 357.805C897.364 359.027 898.585 359.638 899.806 360.248Z",
    fill: "url(#paint3_linear_1005_33979)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.851 973.499C395.571 1027.25 463.942 1059.01 529.871 1076.11C532.709 1077.53 536.372 1078.13 540.859 1078.86C544.094 1079.38 547.756 1079.98 551.847 1081C586.032 1081 612.892 1051.68 612.892 1019.92C612.892 988.158 593.358 963.725 566.498 956.396C517.662 944.18 471.267 922.191 434.64 885.543C368.711 819.576 344.293 751.165 341.851 663.209C339.409 631.448 310.108 604.572 275.922 604.572C263.713 604.572 249.063 609.459 239.295 616.788C229.528 624.118 224.644 631.448 219.761 641.221C214.877 650.993 214.877 663.209 214.877 675.425C217.319 702.299 222.202 729.174 227.086 756.049L227.086 756.051C229.281 764.104 231.257 771.938 233.211 779.683C237.777 797.788 242.222 815.412 249.062 834.235C258.83 861.11 273.48 885.543 290.573 909.975C305.224 934.407 322.317 953.953 341.851 973.499Z",
    fill: "url(#paint4_linear_1005_33979)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M341.853 279.623C300.342 335.817 266.157 411.558 249.064 484.854C249.064 489.883 247.915 494.912 246.404 501.52C245.714 504.542 244.947 507.895 244.181 511.729C249.064 545.934 280.808 567.923 314.993 563.037C339.411 560.594 356.504 541.048 363.829 519.059C380.922 457.979 405.34 394.455 437.083 352.92C493.245 277.18 571.383 218.543 666.613 191.668C698.357 184.338 717.892 155.019 713.008 123.257C708.125 89.0522 678.822 67.0631 644.637 71.9496H639.754C517.664 106.155 412.665 181.894 341.853 279.623Z",
    fill: "url(#paint5_linear_1005_33979)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1005_33979",
    x1: 895.681,
    y1: 1068.33,
    x2: 334.965,
    y2: 110.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1005_33979",
    x1: 895.681,
    y1: 1068.33,
    x2: 334.965,
    y2: 110.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1005_33979",
    x1: 895.681,
    y1: 1068.33,
    x2: 334.965,
    y2: 110.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1005_33979",
    x1: 895.681,
    y1: 1068.33,
    x2: 334.965,
    y2: 110.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1005_33979",
    x1: 895.681,
    y1: 1068.33,
    x2: 334.965,
    y2: 110.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1005_33979",
    x1: 895.681,
    y1: 1068.33,
    x2: 334.965,
    y2: 110.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.1320563a767dcf8e4fd3a8432d003348.svg";
export { ForwardRef as ReactComponent };